//
// Copyright (c) 2018 Nutanix Inc. All rights reserved.
//
// HomePage - Base page inside which all the pages are rendered.
//

// Libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { apiFetchRequest } from '../../actions';

// Local Components
import { logger } from '../../utils';
import HomePageLayout from './HomePageLayout.jsx';
// ---------
// Home Page
// ---------

export class HomePage extends Component {
    static propTypes = {
        // Public props
        children: PropTypes.node.isRequired,
        navigation: PropTypes.array,
        // Router props
        match: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
        // Store props
        oauth: PropTypes.object,
        application: PropTypes.object,
    };

    componentDidMount() {
        // Load all the pages
        logger('iam:HomePage', this.props.oauth);
    }

    render() {
        const { children, oauth, navigation, application = {} } = this.props;

        console.log('========= HOME PAGE ');
        console.log(oauth);
        return (
            <HomePageLayout
                navigation={navigation}
                oauth={oauth}
                toaster={application ? application.toaster : null}
            >
                {children}
            </HomePageLayout>
        );
    }
}

const mapStateToProps = state => {
    return {
        application: state.application,
        oauth: state.oauth,
    };
};

export default withRouter(
    connect(mapStateToProps, {
        apiFetchRequest,
    })(HomePage)
);
